export default __webpack_public_path__ + "static/media/FondoMiseguro.5a054d44.jpg";